import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { axiosPrivate } from '../api/axiosapi';
import { axiosapi } from '../api/axiosapi';
import jwt_decode from "jwt-decode";
import { useNavigate } from 'react-router-dom';
import { addUserDetailsToState } from '../redux/ActionCreators'



const useAxiosPrivate = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const accessToken = useSelector((state) => state.user?.userinfo?.accessToken);


    useEffect(() => {
        const requestIntercept = axiosPrivate.interceptors.request.use((config) => {

            if (!config.headers["Authorization"]) {
                config.headers['Authorization'] = `Bearer ${accessToken}`
            }
            return config;
        }, (error) => Promise.reject(error))

        const responseIntercept = axiosPrivate.interceptors.response.use((response) => response, async (error) => {
            const prevRequest = error?.config;

            if (error?.response?.status === 403 && !prevRequest?.sent) {

                prevRequest.sent = true;
                try {
                    const response = await axiosapi.get('/auth/refresh', { withCredentials: true });
                    console.log("JII", response.data.accessToken)
                    let decoded = jwt_decode(response.data.accessToken);

                    const userInfo = {
                        email: decoded.email,
                        name: decoded.name,
                        id: decoded.id,
                        accessToken: response.data.accessToken,
                        userRoles: decoded.userRoles
                    }
                    console.log("ITSSSSS DECODEDEEE", userInfo)
                    dispatch(addUserDetailsToState(userInfo));
                    prevRequest.headers.Authorization = `Bearer ${response.data.accessToken}`

                    return axiosPrivate(prevRequest);
                }
                catch (error) {
                    navigate("/notloggedin")
                }



            }
            return Promise.reject(error);

        })


        return () => {
            axiosPrivate.interceptors.request.eject(requestIntercept);
            axiosPrivate.interceptors.request.eject(responseIntercept);

        }




    }, [])
    return axiosPrivate;

}
export default useAxiosPrivate;